export default "__VITE_ASSET__BufyG2YI__"